import { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// FAQ content, grouped by section
const faqSections = [
  {
    title: "Signing in and Adding child",
    items: [
      {
        q: "How to Sign up in to the app as a parent?",
        a: "Go to the SIGN UP option in Login Page. Fill the details of Name and Mobile number. Kindly enter the same mobile number which is registered in the school records.",
      },
      {
        q: "How to add child’s school bus?",
        a: "Click on the up arrow button on the bottom right corner of the app. A new page will appear with plus (+) option. Search your school (optionally enter admission number of the child) and tap on request button. Once the school admin confirms your request, you will be able to track the school bus in real time.",
      },
    ],
  },
  {
    title: "Live Tracking",
    items: [
      {
        q: "How to check the location of the bus?",
        a: "Click on the up arrow button on the bottom right corner of the app. Click on start tracking below child name to start tracking the bus. Only registered parents will be able to track the bus location in real time. You won’t be able to track the bus if it is not in trip.",
      },
      {
        q: "How to find out the location of the bus stop?",
        a: "Black pins on the map are the bus stops and red pin is your subscribed stop. Route travelled by bus will be green and remaining will be red.",
      },
      {
        q: "When will the bus reach at bus stop?",
        a: "You will receive a notification indicating the expected time of arrival (ETA) of the bus at your bus stop.",
      },
    ],
  },
  {
    title: "Attendance",
    items: [
      {
        q: "When will I receive the attendance notification?",
        a: "Once RFID card is swiped in bus or detected by UHF reader you will receive attendance notification.",
      },
    ],
  },
  {
    title: "Emergency Information",
    items: [
      {
        q: "Where to find driver’s contact?",
        a: "Tap on the name of bus in bottom sheet when bus is selected. A new page will appear in which you can see the Bus details.",
      },
      {
        q: "How to reach Dhundhoo Support Desk?",
        a: "Tap on the menu button on the left top corner of the app. Tap on help button, write your queries and tap on submit button. The query will be sent via your mobile’s default email client. You will get a response from our support team on the same email address.",
      },
    ],
  },
  {
    title: "Safety Measures",
    items: [
      {
        q: "What are the measures for safety of kids in Dhundhoo powered school buses?",
        a: "Dhundhoo smart devices are SOS enabled. Drivers can alert admins in case of emergency.",
      },
    ],
  },
  {
    title: "Notifications and Alerts",
    items: [
      {
        q: "Why am I not receiving any notifications?",
        a: "You have to allow the notification during the request after downloading the app. If you have disabled that option then you will not receive any notifications. To enable notifications again, go to the settings of the mobile and then go to Dhundhoo in the settings. You will find the notification button from where you can turn on the notifications for the app.",
      },
      {
        q: "Why am I getting delayed notifications?",
        a: "Sometimes due to poor internet connectivity, you may get delayed notifications.",
      },
    ],
  },
];

function Faq() {
  // key = `${sectionIndex}-${itemIndex}` of the currently open panel, per section (accordion behaviour)
  const [expanded, setExpanded] = useState({});

  const handleChange = (sectionIndex, itemIndex) => (event, isExpanded) => {
    setExpanded((prev) => ({
      ...prev,
      [sectionIndex]: isExpanded ? itemIndex : false,
    }));
  };

  return (
    <MDBox
      sx={{
        minHeight: "100vh",
        bgcolor: "#f4f6f8",
        py: { xs: 4, md: 6 },
        px: 2,
      }}
    >
      <MDBox
        sx={{
          maxWidth: 860,
          mx: "auto",
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          p: { xs: 3, md: 5 },
        }}
      >
        <MDTypography variant="h3" fontWeight="bold" mb={1}>
          Frequently Asked Questions
        </MDTypography>
        <MDTypography variant="body2" color="text" mb={4}>
          Everything you need to know about using the Dhundhoo parent app.
        </MDTypography>

        {faqSections.map((section, sIdx) => (
          <MDBox key={section.title} mb={4}>
            <MDTypography
              variant="h6"
              fontWeight="bold"
              display="flex"
              alignItems="center"
              mb={1.5}
            >
              <Icon fontSize="small" sx={{ mr: 1, color: "info.main" }}>
                fiber_manual_record
              </Icon>
              {section.title}
            </MDTypography>

            {section.items.map((item, iIdx) => (
              <Accordion
                key={item.q}
                expanded={expanded[sIdx] === iIdx}
                onChange={handleChange(sIdx, iIdx)}
                disableGutters
                elevation={0}
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px !important",
                  mb: 1,
                  "&:before": { display: "none" },
                  overflow: "hidden",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    bgcolor: expanded[sIdx] === iIdx ? "#f0f4ff" : "white",
                    "& .MuiAccordionSummary-content": { my: 1.25 },
                  }}
                >
                  <MDTypography variant="button" fontWeight="medium">
                    {item.q}
                  </MDTypography>
                </AccordionSummary>
                <AccordionDetails sx={{ bgcolor: "#fafafa" }}>
                  <MDTypography variant="body2" color="text">
                    {item.a}
                  </MDTypography>
                </AccordionDetails>
              </Accordion>
            ))}
          </MDBox>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default Faq;